module.exports = __webpack_public_path__ + "static/img/9.0674e2f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/9.png
// module id = 58zg
// module chunks = 0